export default __webpack_public_path__ + "static/media/logo-epispost.2d16726a.png";